
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexIgPeIDfcGKSF9_455BX74c6tk_45Eu91WpxEb_45VK6ZmnFkgMeta } from "C:/git/order-app-2/pages/index.vue?macro=true";
import { default as logg_45innowiKfl7bBvYuhQSGStt6Z7_bsdnp1wTYgdbSgRvWb9MMeta } from "C:/git/order-app-2/pages/logg-inn.vue?macro=true";
import { default as sok6ygMWrbL5ZrgcvoflBtJvsURYSVIYtgOCNjX_45LW6YZwMeta } from "C:/git/order-app-2/pages/domene/sok.vue?macro=true";
import { default as handlekurvVMeZfsDB5Z_45nIq6vlGQxd5cX6vTvbDPyXfLi1f_6gjkMeta } from "C:/git/order-app-2/pages/handlekurv.vue?macro=true";
import { default as kvitteringcGvN24k7VEHdJ4B9VfrQxtsVCmv_45oABJf2_45pEg7qVk0Meta } from "C:/git/order-app-2/pages/kvittering.vue?macro=true";
import { default as velg_45kundew9sRE_45JOgXa2fSJYTTCsVus8HB0eWVSmz_45x3apaccCAMeta } from "C:/git/order-app-2/pages/velg-kunde.vue?macro=true";
import { default as cloud_45serverdOGYCb76GEHPD1LlaQZl6WXUpWfUQq_e0CUluZx5PYoMeta } from "C:/git/order-app-2/pages/cloud-server.vue?macro=true";
import { default as verifiseringFJei9S50sNyOeVE5VbzsQxhWBCu9EjEMkaSvM20CzkwMeta } from "C:/git/order-app-2/pages/verifisering.vue?macro=true";
import { default as microsoft_45365Jjwl_W5yJg5FQ8cVV_45CSL_nExTnc4BCLboitDJ9mubMMeta } from "C:/git/order-app-2/pages/microsoft-365.vue?macro=true";
import { default as opprett_45kunde6mGA1lJ352NUwlYj_H5QQ122Q_45MpofBtMQthw0Q1J3YMeta } from "C:/git/order-app-2/pages/opprett-kunde.vue?macro=true";
import { default as indexBZsz32BPKGtfhwhiKKhr0sgWl2_VjhtsNNxbvDg9yZMMeta } from "C:/git/order-app-2/pages/domene/analyse/index.vue?macro=true";
import { default as _91domene_93HoNplP5gpwLTcrqQ8XRssiK_C2wbnaoSpeP3BSkacDEMeta } from "C:/git/order-app-2/pages/domene/analyse/[domene].vue?macro=true";
import { default as _91data_93ORtXVuN5lS43jS2WiFKtJw1oLnbAuoVI3TFZi4wlSEcMeta } from "C:/git/order-app-2/pages/passthrough-auth/kunde/[data].vue?macro=true";
import { default as indexacB8QEeZ_457Odyq4Unf3dGgSKaMw7tBrjNGKrv479SsQMeta } from "C:/git/order-app-2/pages/domene/tilleggstjenester/index.vue?macro=true";
import { default as _91data_93EslD36LvAWVVUxm60ikZ4XT3YBoGAhuXt_3TtlUhD_MMeta } from "C:/git/order-app-2/pages/passthrough-auth/partner/[data].vue?macro=true";
import { default as _91domene_93QB0ZJY47F6ikgi3Rj6Q_lZZrhnd_45e6gs0FL1uNiw_45RwMeta } from "C:/git/order-app-2/pages/domene/tilleggstjenester/[domene].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("C:/git/order-app-2/pages/index.vue")
  },
  {
    name: "logg-inn",
    path: "/logg-inn",
    meta: logg_45innowiKfl7bBvYuhQSGStt6Z7_bsdnp1wTYgdbSgRvWb9MMeta || {},
    alias: ["/login"],
    component: () => import("C:/git/order-app-2/pages/logg-inn.vue")
  },
  {
    name: "domene-sok",
    path: "/domene/sok",
    meta: sok6ygMWrbL5ZrgcvoflBtJvsURYSVIYtgOCNjX_45LW6YZwMeta || {},
    alias: ["/domenesok"],
    component: () => import("C:/git/order-app-2/pages/domene/sok.vue")
  },
  {
    name: "handlekurv",
    path: "/handlekurv",
    meta: handlekurvVMeZfsDB5Z_45nIq6vlGQxd5cX6vTvbDPyXfLi1f_6gjkMeta || {},
    component: () => import("C:/git/order-app-2/pages/handlekurv.vue")
  },
  {
    name: "kvittering",
    path: "/kvittering",
    component: () => import("C:/git/order-app-2/pages/kvittering.vue")
  },
  {
    name: "velg-kunde",
    path: "/velg-kunde",
    meta: velg_45kundew9sRE_45JOgXa2fSJYTTCsVus8HB0eWVSmz_45x3apaccCAMeta || {},
    component: () => import("C:/git/order-app-2/pages/velg-kunde.vue")
  },
  {
    name: "cloud-server",
    path: "/cloud-server",
    component: () => import("C:/git/order-app-2/pages/cloud-server.vue")
  },
  {
    name: "verifisering",
    path: "/verifisering",
    meta: verifiseringFJei9S50sNyOeVE5VbzsQxhWBCu9EjEMkaSvM20CzkwMeta || {},
    component: () => import("C:/git/order-app-2/pages/verifisering.vue")
  },
  {
    name: "microsoft-365",
    path: "/microsoft-365",
    meta: microsoft_45365Jjwl_W5yJg5FQ8cVV_45CSL_nExTnc4BCLboitDJ9mubMMeta || {},
    alias: ["/office365"],
    component: () => import("C:/git/order-app-2/pages/microsoft-365.vue")
  },
  {
    name: "opprett-kunde",
    path: "/opprett-kunde",
    component: () => import("C:/git/order-app-2/pages/opprett-kunde.vue")
  },
  {
    name: "domene-analyse",
    path: "/domene/analyse",
    meta: indexBZsz32BPKGtfhwhiKKhr0sgWl2_VjhtsNNxbvDg9yZMMeta || {},
    component: () => import("C:/git/order-app-2/pages/domene/analyse/index.vue")
  },
  {
    name: "domene-analyse-domene",
    path: "/domene/analyse/:domene()",
    component: () => import("C:/git/order-app-2/pages/domene/analyse/[domene].vue")
  },
  {
    name: "passthrough-auth-kunde-data",
    path: "/passthrough-auth/kunde/:data()",
    meta: _91data_93ORtXVuN5lS43jS2WiFKtJw1oLnbAuoVI3TFZi4wlSEcMeta || {},
    alias: ["/kunde/:data(.*)"],
    component: () => import("C:/git/order-app-2/pages/passthrough-auth/kunde/[data].vue")
  },
  {
    name: "domene-tilleggstjenester",
    path: "/domene/tilleggstjenester",
    meta: indexacB8QEeZ_457Odyq4Unf3dGgSKaMw7tBrjNGKrv479SsQMeta || {},
    component: () => import("C:/git/order-app-2/pages/domene/tilleggstjenester/index.vue")
  },
  {
    name: "passthrough-auth-partner-data",
    path: "/passthrough-auth/partner/:data()",
    meta: _91data_93EslD36LvAWVVUxm60ikZ4XT3YBoGAhuXt_3TtlUhD_MMeta || {},
    alias: ["/partner/:data(.*)"],
    component: () => import("C:/git/order-app-2/pages/passthrough-auth/partner/[data].vue")
  },
  {
    name: "domene-tilleggstjenester-domene",
    path: "/domene/tilleggstjenester/:domene()",
    meta: _91domene_93QB0ZJY47F6ikgi3Rj6Q_lZZrhnd_45e6gs0FL1uNiw_45RwMeta || {},
    component: () => import("C:/git/order-app-2/pages/domene/tilleggstjenester/[domene].vue")
  }
]